import React from "react";
import { useContext } from "react";
import { Navigate } from "react-router-dom";
import Footer from "../Components/Footer";
import Header from "../Components/HeaderAdmin";
import SidebarAdmin from "../Components/SidebarAdmin";
import { AdminContext } from "../Context/AdminContext";
import { GuestApi } from "../utils/api";
import '../assets/css/dashboard-theme.css';

const AdminAuthLayout = (props) => { 
    const { children } = props;
    const { admin, setAdmin } = useContext(AdminContext);

    const logoutHandle = async () => {
        try {
            const { refreshToken } = admin;
            await GuestApi.post("/admin/logout", {refreshToken});
        } catch (e) {
            const { response } = e;
            console.log(`😱 Axios request failed: ${response}`);
        }
        // in any case user data must be removed from client side
        localStorage.removeItem('admin_data');
        setAdmin(null);
        window.localStorage.clear();
        window.location.reload();
    }
    
    if(admin == null) return <Navigate to='/admin-login' />;

    return (
        <div className='dashboard-layout-wrapper'>
            {/* Background glow effect similar to GuestLayout */}
            <div
                className='hero-bg-glow'
                style={{
                    position: 'fixed',
                    top: '-30%',
                    right: '-30%',
                    width: '80%',
                    height: '80%',
                    opacity: 0.1,
                }}
            ></div>

            <SidebarAdmin logoutHandle={logoutHandle} />
            <main className='main-content position-relative border-radius-lg'>
                <Header logoutHandle={logoutHandle} />
                <div className='container-fluid py-4'>{children}</div>
                <Footer />
            </main>
        </div>
    );
};

export default AdminAuthLayout;
